/** Add translated vocabulary to the Spanish page Review section. */

import { joinItemText, splitItemText } from '../utils/itemTextParts';

export const SPANISH_REVIEW_SECTION_TITLE = 'review';

export type SpanishReviewEntry = {
  spanish: string;
  /** Full sentence the word came from (Spanish). */
  sourceSentence: string;
};

export type SpanishReviewHandler = (entry: SpanishReviewEntry) => void;

let reviewHandler: SpanishReviewHandler | null = null;

export function setSpanishReviewHandler(handler: SpanishReviewHandler | null): void {
  reviewHandler = handler;
}

/** True when the translated phrase is a single token (not a sentence). */
export function isSpanishReviewWord(phrase: string): boolean {
  const t = phrase.trim().replace(/\s+/g, ' ');
  if (t.length < 2) return false;
  return !/\s/.test(t);
}

/** First line = word + period (card label); second line = source sentence. */
export function formatSpanishReviewItemText(spanish: string, sourceSentence: string): string {
  const word = spanish.trim().replace(/\.+$/, '');
  const sentence = sourceSentence.trim().replace(/\s+/g, ' ');
  if (!word) return '';
  const title = `${word}.`;
  if (!sentence || sentence === word) return title;
  return joinItemText(title, sentence);
}

export function spanishFromReviewItemText(text: string): string {
  return splitItemText(text).title.trim().replace(/\.+$/, '');
}

export function findSpanishReviewSectionIndex(
  sections: ReadonlyArray<{ title: string }>
): number {
  return sections.findIndex(s => s.title.trim().toLowerCase() === SPANISH_REVIEW_SECTION_TITLE);
}

export function tryAddSpanishReviewWord(spanish: string, sourceSentence: string): void {
  if (!reviewHandler || !isSpanishReviewWord(spanish)) return;
  reviewHandler({
    spanish: spanish.trim(),
    sourceSentence: sourceSentence.trim().replace(/\s+/g, ' '),
  });
}
